import React from 'react';
import { useSelector } from 'react-redux';

import { getStatuses } from 'features/order-tracker/store/selectors';
import {
  Message,
  OrderNumber,
  OrderStatus,
} from './components';

import styles from './style.module.scss';

export const SnapshotCardHeader: React.FC = () => {
  const {
    orderStatuses,
    orderStatusFromGOC,
  } = useSelector(getStatuses);
  const status = orderStatusFromGOC || orderStatuses[0];

  return (
    <div className={styles.header}>
      <OrderNumber />
      <OrderStatus orderStatus={status} />
      <Message orderStatus={status} />
    </div>
  );
};
